// app/variants/statsVariants.ts
import { Variants } from "framer-motion";

export const statsContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.3, // เว้น 0.3s ระหว่างแต่ละกล่อง
    },
  },
};

export const statsItem: Variants = {
  hidden: { y: 50, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 120,
      damping: 12,
    },
  },
};
